import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "components/Input/Input";
import Button from "components/Button/Button";
import { IconWarning } from "icons";
import userService from "api/user/user.service";

const schema = yup
  .object({
    email: yup.string().required("Please enter a valid e-mail address!").email("Please enter a valid e-mail address!"),
  })
  .required();

const ForgotPassword = ({ email, onClose, setCurrentStep }: any) => {
  const [isEmailSent, setIsEmailSent] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: email || "",
    },
  });

  const onValid = (data: any) => {
    console.log(data);
    userService
      .forgotPassword({ email: data.email })
      .then(() => setIsEmailSent(true))
      .catch((e) => console.log(e));
  };
  const onHandleSubmit = () => {
    handleSubmit(onValid, (e) => console.log(e))();
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onHandleSubmit();
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-2.5 pb-5 px-2.5">
        <h3 className="text-h3 text-center text-white">Forgot Password?</h3>
        <h4 className="text-bodyM text-center text-grey">No worries, we`ll send you reset instructions</h4>
      </div>

      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-2.5">
          <Input onKeyDown={handleKeyPress} error={errors.email?.message} {...register("email")} placeholder="E-mail Address" containerClassName="w-full"></Input>
          {isEmailSent && (
            <span className="flex text-green text-h6 items-center gap-[5px]">
              <IconWarning className="h-[17px] w-[17px]" />
              Email sent! Please follow the reset instructions.
            </span>
          )}
        </div>
        <div className="flex flex-col gap-2.5">
          {!isEmailSent && (
            <>
              <Button className="btn-primary w-full" onClick={onHandleSubmit}>
                Continue
              </Button>
              <Button className="btn-secondary w-full" onClick={() => setCurrentStep(1)}>
                Back to Sign In
              </Button>
            </>
          )}
          {isEmailSent && (
            <Button className="btn-secondary w-full" onClick={onClose}>
              Close
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
